// 导入组件
import paging from './src/paging.vue'

// 为组件提供 install 安装方法，供按需引入
paging.install = function (Vue) {
  Vue.component(paging.name, paging)
}

// 默认导出组件
export default paging
